module.exports = __webpack_public_path__ + "static/img/646_phase_function_Paper_PointsHejduk_Prediction.78b362d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/646_phase_function_Paper_PointsHejduk_Prediction.png
// module id = z3Vs
// module chunks = 0